import { faXmarkCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import CButton from "../../../../components/buttons/Button";
import CTextAreaField from "../../../../components/inputBoxes/textArea-input";
import ArticleRejectHooks from "../hooks/articleReject";

const ArticleRejectReason = () => {
  let navigate = useNavigate();
  const { order_id } = useParams();
  const [reason, setReason] = useState();
  const articleHandle = async () => {
    const res = await ArticleRejectHooks({
      rejected_reason: reason,
      doi_id: order_id,
    });
    if (res.status === 200) navigate("/dashboard/new-orders");
  };

  return (
    <>
      <div className="row mt-4">
        <div className="articleRejectReason">
          <div className="col-md-1 col-sm-12 text-end p-0">
            <FontAwesomeIcon
              icon={faXmarkCircle}
              className="text-danger fa-2x mt-2 me-2"
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <h5 className="text-dark mb-0 fw-bold">Request Rejected.</h5>
            <small className="text-dark">
              Please let the marketer know why.
            </small>
          </div>
        </div>
        <div className="col-7"></div>
      </div>
      {/* <br></br>
      <br></br>
      <br></br>
      <br></br>
      <h5 className="text-dark ms-5 fw-bold">Questions to be decided</h5> */}
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div className="row">
        <div className="col-1"></div>
        <div className="col-md-5 col-sm-12">
          <CTextAreaField
            name={"rejected_reason"}
            placeholder={"Text"}
            rowsTextArea={6}
            customClassDiv={"mb-5 text-dark"}
            customClassInput={"bg-primary-soft"}
            functionName={(name, value) => {
              setReason({ ...reason, [name]: value });
            }}
          />
          <div className="mb-5 text-center">
            <CButton
              btnClasses={"btn px-4 mb-3 fw-bold text-white"}
              IsOutline={false}
              innertext={"Done"}
              btnCustomStyle={{
                backgroundColor: "#044389",
              }}
              functionName={() => articleHandle()}
            />
            <Link
              to={"/dashboard/new-orders"}
              className="text-decoration-underline"
            >
              Skip
            </Link>
          </div>
        </div>
        <div className="col-6"></div>
      </div>
      <div className="clearfix mb-5"></div>
    </>
  );
};

export default ArticleRejectReason;
